import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';
import CollapsibleContainer from '../../components/CollapsibleContainer';
import UpperContainer from '../../components/UpperContainer';
import { animateToScreen } from '../../redux/ui/actions';
import { setTicketPassengers } from '../../redux/cardReader/actions';
import { TICKET_TYPE_VALUE_TICKET } from '../../constants';
import CurrentZoneSelector from '../../containers/CurrentZoneSelector';
import CurrentZoneSelectorWrapper from '../../molecules/CurrentZoneSelectorWrapper';
import RegionDescription from '../../molecules/RegionDescription';
import BackButtonContainer from '../../molecules/BackButtonContainer';
import TextColumnContent from '../../molecules/TextColumnContent';
import { H2, P, A, H4, TextHeavy, TextBig } from '../../components/Typography';

class ValueTicketRegionTexts extends PureComponent {
  componentDidMount() {
    this.props.resetPassengers();
  }

  render() {
    const { goBackToHome, goToExtraTicketFlow, t } = this.props;
    return (
      <>
        <BackButtonContainer
          fadeIn
          home={t('Generic.breadcrumbHome')}
          homeLink={t('Generic.breadcrumbHomeLink')}
          secondaryHome={t('Generic.breadcrumbSecondaryHome')}
          secondaryHomeLink={t('Generic.breadcrumbSecondaryHomeLink')}
          textPrev={t('Flows.home')}
          text={t('Flows.valueTicket')}
          onClick={goBackToHome}
        />
        <TextColumnContent paddingTop={-100}>
          <H2>
            <Trans i18nKey="ValueTicketRegion.title" />
          </H2>
          <UpperContainer>
            <RegionDescription
              description={
                <>
                  <P>
                    <Trans i18nKey="ValueTicketRegion.description" />
                  </P>
                  <TextHeavy>
                    <Trans i18nKey="ValueTicketRegion.extraTicketText" />{' '}
                  </TextHeavy>
                  <P>
                    <A onClick={goToExtraTicketFlow}>
                      <Trans i18nKey="ValueTicketRegion.extraTicketLinkText" />{' '}
                    </A>
                  </P>
                </>
              }
              disclaimer={
                <>
                  <H4>
                    <Trans i18nKey="ValueTicketRegion.disclaimerTitle" />
                  </H4>
                  <TextBig>
                    <Trans i18nKey="ValueTicketRegion.disclaimer" />
                  </TextBig>
                </>
              }
            />
            <CurrentZoneSelectorWrapper>
              <CurrentZoneSelector
                ticketType="valueTicket"
                additionalInfoI18nKey="ValueTicketRegion.disclaimer"
              />
            </CurrentZoneSelectorWrapper>
          </UpperContainer>
          <CollapsibleContainer>
            <Collapsible
              trigger={t('Generic.additionalInfoAndZone')}
              transitionTime={300}
            >
              <RegionDescription
                description={
                  <>
                    <P>
                      <Trans i18nKey="ValueTicketRegion.description" />
                    </P>
                    <TextHeavy>
                      <Trans i18nKey="ValueTicketRegion.extraTicketText" />{' '}
                    </TextHeavy>
                    <P>
                      <A onClick={goToExtraTicketFlow}>
                        <Trans i18nKey="ValueTicketRegion.extraTicketLinkText" />{' '}
                      </A>
                    </P>
                  </>
                }
                disclaimer={
                  <>
                    <H4>
                      <Trans i18nKey="ValueTicketRegion.disclaimerTitle" />
                    </H4>
                    <TextBig>
                      <Trans i18nKey="ValueTicketRegion.disclaimer" />
                    </TextBig>
                  </>
                }
              />
              <CurrentZoneSelectorWrapper>
                <CurrentZoneSelector
                  ticketType="valueTicket"
                  additionalInfoI18nKey="ValueTicketRegion.disclaimer"
                />
              </CurrentZoneSelectorWrapper>
            </Collapsible>
          </CollapsibleContainer>
        </TextColumnContent>
      </>
    );
  }
}

ValueTicketRegionTexts.propTypes = {
  goBackToHome: PropTypes.func.isRequired,
  goToExtraTicketFlow: PropTypes.func.isRequired,
  resetPassengers: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  goToExtraTicketFlow: () => dispatch(animateToScreen('ExtraTicketRegion')),
  goBackToHome: () => dispatch(animateToScreen('Home')),
  resetPassengers: () => dispatch(setTicketPassengers(TICKET_TYPE_VALUE_TICKET, 1)), // eslint-disable-line
});

// prettier-ignore
export default connect(null, mapDispatchToProps)(ValueTicketRegionTexts);
